import { render } from "./horizental-nav.vue?vue&type=template&id=d2640880"
import script from "./horizental-nav.vue?vue&type=script&lang=js"
export * from "./horizental-nav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__